export default "__VITE_ASSET__KWJXpOGQ__"